import * as React from 'react';
import StaticView from './StaticView';
import { TreeSelect } from 'antd';
import { get } from 'pc-sales/utils/http';

export default class TreeSelectField extends React.Component<any> {
    static fieldName = 'treeSelect';
    static type = 'Select';
    static validateTrigger = 'onChange';
    public static defaultProps = {
        size: 'default'
    };
    private tree: HTMLElement;
    state: any = {
        value: this.props.value,
        asyncTreeData: []
    };

    /**
     * value change
     * @param value
     */
    changeHandler = (value: any) => {
        this.setState({ value: value });
        const { onChange } = this.props;
        if (onChange) onChange(value);
    };

    /**
     * load data control
     * @param asyncTreeData
     */
    loadDataHandler = (asyncTreeData: any) => {
        const { loadData } = this.props;
        return Promise.resolve(loadData && loadData(asyncTreeData));
    };

    /**
     * get tree node description
     * @param treeData
     * @param values
     */
    getTreeDesc = (treeData: any[], values: any[]) => {
        const getChildrenDesc = (treeData: any[]) => treeData.reduce((prev: any, { key, label, title, children, value }: any): any => {
            return {
                ...prev,
                ...(children ? getChildrenDesc(children) : {
                    [key || value]: title || label
                })
            };
        }, {});
        let dataMap = getChildrenDesc(treeData);
        return values.filter((key: any) => !!dataMap[key]).map((key: any) => dataMap[key]).join(' / ');
    };

    componentDidMount() {
        const { url, adaptFn, initData } = this.props;
        url && get(url).then((ret: any) => {
            this.setState({ asyncTreeData: (adaptFn ? adaptFn(ret) : ret) || [] });
        });
        typeof initData === 'function' && initData((asyncTreeData: any) => asyncTreeData && this.setState({ asyncTreeData }));
    }

    UNSAFE_componentWillReceiveProps(nextProps: any) {
        this.props.value !== nextProps.value && this.setState({ value: nextProps.value });
        nextProps.treeData && nextProps.treeData.length && this.setState({ asyncTreeData: nextProps.treeData });
    }

    // 数据回填显示方式
    private static strategy: { [key: string]: any; } = {
        'all': TreeSelect.SHOW_ALL,
        'parent': TreeSelect.SHOW_PARENT,
        'child': TreeSelect.SHOW_CHILD
    };

    // 过滤搜索功能
    filterHandler = (value: string = '', treeNode: any) => {
        return treeNode.props.title.indexOf(value) > -1;
    };
    // 对有全部选项的数据进行统一数据处理
    filterData = (treeData: any, strategy: string) => {
        if (treeData && treeData.length > 0 && treeData[0].key === 'all') {
            treeData[0].value = Array.from(treeData[0].children, (val: any) => val.value).join(',');
            return { filterTreeData: treeData, filterStrategy: 'parent' };
        }
        return { filterTreeData: treeData, filterStrategy: strategy };
    };

    render() {
        const { value, asyncTreeData } = this.state;
        const { placeholder, treeData, multiple, size, treeCheckable, allowClear, disabled, getPopupContainer,
                dropdownClassName, treeDefaultExpandedKeys, staticView, treeDefaultExpandAll, heightLimit,
                labelInValue, strategy, loadData } = this.props;
        const { filterTreeData, filterStrategy } = this.filterData(treeData, strategy);
        let sourceData = asyncTreeData.length && asyncTreeData || filterTreeData;
        return (staticView && disabled)
            ? <StaticView display={(sourceData && value) ? this.getTreeDesc(sourceData, value) : '-'} wrap={true}/>
            : <div className={heightLimit ? 'treeSelect' : 'account-type-location-parent'}
                   ref={(ctx: HTMLElement) => this.tree = ctx}
                   style={{ position: 'relative' }}>
                <TreeSelect value={value} treeData={sourceData}
                            showCheckedStrategy={TreeSelectField.strategy[filterStrategy]}
                            dropdownStyle={{ maxHeight: 175, overflowY: 'auto', zIndex: 1050 }}
                            filterTreeNode={this.filterHandler}
                            placeholder={placeholder} labelInValue={labelInValue}
                            getPopupContainer={getPopupContainer && (() => this.tree)}
                            treeDefaultExpandedKeys={treeDefaultExpandedKeys} dropdownClassName={dropdownClassName}
                            onChange={this.changeHandler} treeDefaultExpandAll={treeDefaultExpandAll}
                            treeCheckable={treeCheckable} size={size} multiple={multiple}
                            allowClear={allowClear} disabled={disabled} loadData={!!loadData ? this.loadDataHandler : null}/>
            </div>;
    }
}
